import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface NavigationState {
    isNavExpanded: boolean
    setIsNavExpanded: (isNavExpanded: boolean) => void
}

export const useNavigationStore = create<NavigationState>()(
  persist(
    (set) => ({
      isNavExpanded: true,
      setIsNavExpanded: (isNavExpanded) => set({ isNavExpanded: isNavExpanded }),
    }),
    {
            name: "navigation-storage", // unique name for localStorage key
    }
    )
);
